import { Plan, PlanPermission } from "@/api/plans";

export interface PlansState {
  currentPlan: Plan | null;
  availablePlans: Plan[];
  permissions: PlanPermission[];
  isLoading: boolean;
  error: string | null;
  hasAttemptedFetch: boolean;
}

// Утилиты для работы с разрешениями
export const hasPermission = (
  userPermissions: number,
  requiredPermission: number,
): boolean => {
  return (userPermissions & requiredPermission) === requiredPermission;
};

export const hasAnyPermission = (
  userPermissions: number,
  requiredPermissions: number[],
): boolean => {
  return requiredPermissions.some((permission) =>
    hasPermission(userPermissions, permission),
  );
};

export const hasAllPermissions = (
  userPermissions: number,
  requiredPermissions: number[],
): boolean => {
  return requiredPermissions.every((permission) =>
    hasPermission(userPermissions, permission),
  );
};

// Утилиты для работы с планами
export const getPlanPermissions = (
  plan: Plan,
  availablePermissions: PlanPermission[],
): PlanPermission[] => {
  return availablePermissions.filter(
    (permission) => (plan.mask & permission.bit) === permission.bit,
  );
};

export const canAccessFeature = (
  currentPlan: Plan | null,
  featureBit: number,
): boolean => {
  if (!currentPlan) return false;
  return (currentPlan.mask & featureBit) === featureBit;
};

export const getPlanLimits = (plan: Plan) => {
  return {
    offices: plan.office_count,
    locations: plan.location_count,
    hasUnlimitedOffices:
      plan.office_count === -1 || plan.office_count >= 1000000,
    hasUnlimitedLocations:
      plan.location_count === -1 || plan.location_count >= 1000000,
  };
};

export const isPlanUpgrade = (
  currentPlan: Plan | null,
  targetPlan: Plan,
): boolean => {
  if (!currentPlan) return true;
  return targetPlan.price > currentPlan.price;
};

export const isPlanDowngrade = (
  currentPlan: Plan | null,
  targetPlan: Plan,
): boolean => {
  if (!currentPlan) return false;
  return targetPlan.price < currentPlan.price;
};
